import { SET_NOTIFICATION } from "@/store/mutations.type";
import _ from "lodash";
import i18n from "@/plugins/i18n";
import { CIRCLE_NUMBERS, CONFIG_VALUES, REGEX } from "./constant";

export function isEmpty(str) {
  return !str || 0 === str.trim().length;
}

export function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

export function onlyNumeric(event, value, maxlength) {
  if (!!value) {
    value = value.replace(/[^0-9]/g, "") + "";
    if (value.length > maxlength - 1) {
      event.preventDefault();
    }
  }
  let keyCode = event.which;
  if (keyCode < 48 || keyCode > 57) {
    event.preventDefault();
  }
}

export function onlyDecimal(event, value, maxlength) {
  let keyCode = event.which;
  if ((keyCode < 48 && keyCode !== 46) || keyCode > 57) {
    event.preventDefault();
    return;
  }
  if (!!value) {
    value += "";
    value = value.replace(/[^0-9\.]/g, "") + "";
    if (value.length > maxlength - 1) {
      event.preventDefault();
    }
  }
}

export function formatNumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  if (!isNumeric(number)) {
    return number;
  }
  var value = Number(number);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function NumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  try {
    var value = Number(number);
    var nf = new Intl.NumberFormat();
    return nf.format(value);
  } catch (error) {
    return number;
  }
}

export function toASCII(chars) {
  if (chars === undefined || chars === null || chars === "") {
    return chars;
  }
  chars = chars.replace("ー", "-");
  chars = chars.replace("。", ".");
  let ascii = "";
  for (let i = 0, l = chars.length; i < l; i++) {
    let c = chars[i].charCodeAt(0);
    if (c >= 0xff00 && c <= 0xffef) {
      c = 0xff & (c + 0x20);
    }
    ascii += String.fromCharCode(c);
  }
  ascii = ascii.replace("−", "-");
  return ascii;
}

export function setCaretPosition(id, caretPos) {
  var elem = document.getElementById(id);
  if (elem != null) {
    if (elem.createTextRange) {
      var range = elem.createTextRange();
      range.move("character", caretPos);
      range.select();
    } else {
      if (elem.selectionStart) {
        elem.focus();
        elem.setSelectionRange(caretPos, caretPos);
      } else elem.focus();
    }
  }
}

export function getCurrentLocalDate() {
  return getLocalDate(0);
}

export function getStartLocalDate() {
  return getLocalDate(-1);
}

export function getLocalDate(days) {
  let date = new Date();
  if (-1 === days) {
    date.setDate(1);
  } else {
    date.setDate(date.getDate() - days);
  }
  date = new Date(date - new Date().getTimezoneOffset() * 60000);
  return date.toISOString().substr(0, 10);
}

export function getPaginationInfo(page, limit, count) {
  if (count > 0) {
    let start = (page - 1) * limit;
    let end = start + limit;
    if (end > count) end = count;
    return start + 1 + " - " + end + " の " + count;
  }
  return "0 - 0 の 0";
}

export function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export function formatDate(date, format) {
  let __date = date.getDate();
  let __MM = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
  let __yyyy = date.getFullYear();
  const map = {
    MM: __MM,
    dd: __date,
    yyyy: __yyyy,
    yy: __yyyy.toString().slice(-2),
    HH: date.getHours(),
    ii: date.getMinutes(),
    ss: date.getSeconds(),
  };
  return format.replace(/MM|dd|yyyy|yy|HH|ii|ss/gi, (matched) => map[matched]);
}

const INITIAL_ALERT =
  (color) =>
  (message, timeout = 3000) => {
    vm.$store.commit(SET_NOTIFICATION, {
      color,
      message,
      timeout,
    });
  };
export const ALERT = {
  ERROR: INITIAL_ALERT("error"),
  SUCCESS: INITIAL_ALERT("success"),
  WARNING: INITIAL_ALERT("#FFA000"),
};

//lodash
export const cloneObject = (object) => _.cloneDeep(object);
export const getPathObject = (object, suffix) => _.get(object, suffix);
export const isNullOrUndefined = (value) => _.isNil(value);
export const isNal = (value) => !value || value === 0;

//RULES
export const RULES = {
  sizeBetween(v, min, max) {
    return (
      !(v > max || v < min) ||
      i18n.t("msg.sizeInputBetween", ["価値", min, max])
    );
  },
  lengthBetween(v, min, max) {
    return (
      !(v.length > max || v.length < min) ||
      i18n.t("msg.passwordInputBetween", ["価値", min, max])
    );
  },
  required(v, text) {
    if (typeof v === "string") {
      if (v.trim() === "") return i18n.t("msg.required", [text]);
    }
    return !isNal(v) || i18n.t("msg.required", [text]);
  },
  number(v) {
    return !isNaN(v) || i18n.t("msg.isNumberRequire");
  },
  numberOrNull(v) {
    if (_.isNil(v) || v === "") return true;
    return !isNaN(v) || i18n.t("msg.isNumberRequire");
  },
  integerOrNull(v) {
    if (_.isNil(v) || v === "") return true;
    return REGEX.NOT_NEGATIVE_INTEGER.test(v) || i18n.t("msg.isNumberRequire");
  },
  demicalOrNull(v) {
    if (_.isNil(v) || v === "") return true;
    return REGEX.DECIMAL_NUMBER_INS.test(v) || i18n.t("msg.isNumberRequire");
  },
  email(v, text) {
    return REGEX.EMAIL.test(v) || i18n.t("msg.errorFormat", [text || "email"]);
  },
  phone(v, text) {
    return (
      REGEX.PHONE.test(v) || i18n.t("msg.errorFormat", [text || "phoneNumber"])
    );
  },
  boolean(v, text) {
    return typeof v === "boolean" || i18n.t("msg.required", [text || ""]);
  },
  isSamePass(v, pass) {
    return v === pass || i18n.t("msg.notSamePass");
  },
  attachedImage(v) {
    if (v && v.length) {
      for (let i = 0; i < v.length; i++) {
        if (v[i].size / 1024 / 1024 > CONFIG_VALUES.MAX_FILE_SIZE) {
          return i18n.t("msg.overFileSize", [CONFIG_VALUES.MAX_FILE_SIZE]);
        }
      }
    }
    return true;
  },
};

export const parseBool = (string) => {
  if (string === "true") return true;
  else if (string === "false") return false;
  else return null;
};
export const parseNumberInt = (number) => {
  return parseInt(number) || null;
};

export const PRE_PUSH_QUERY = (object) => {
  ["page", "limit"].forEach((item) => delete object[item]);
};

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function getJpDate() {
  return getDateByTz(process.env.VUE_APP_LOCALE, process.env.VUE_APP_TIMEZONE);
}

export function getDateByTz(locale, timeZone) {
  return new Date(new Date().toLocaleString(locale, { timeZone: timeZone }));
}
